"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _Text = _interopRequireDefault(require("../../Text"));
var _ = require("../../..");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CommentLine = ({
  date = '',
  time = '',
  header = '',
  comment = '',
  icon,
  italic,
  commentInfo,
  subtle,
  customContent,
  ...restProps
}) => {
  const theme = (0, _react2.useTheme)();
  const isMobile = (0, _.useIsMobile)();
  const ariaLabel = `kommentar ${date} klokken ${time}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    theme: theme,
    "data-testid": "comment-line",
    role: "article",
    "aria-label": ariaLabel,
    ...restProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DateWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        subtle: true,
        size: "14px",
        children: time
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        size: isMobile ? '14px' : '16px',
        children: date
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
      "aria-hidden": true,
      children: icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TextWrapper, {
      tabIndex: 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Header, {
        level: 5,
        size: "16px",
        children: header
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        italic: italic,
        subtle: subtle,
        size: "14px",
        paragraph: true,
        children: comment
      }), commentInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        italic: true,
        subtle: true,
        size: "14px",
        children: commentInfo
      }), customContent && customContent]
    })]
  });
};
var _default = exports.default = CommentLine;